import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isMemoSame as _isMemoSame, withMemo as _withMemo, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fca40b6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-gap-[20px] md:tw-flex-row md:tw-justify-between tw-w-full mainWrapper" }
const _hoisted_2 = { class: "tw-w-full" }
const _hoisted_3 = { class: "tw-flex tw-mb-2 tw-gap-[10px]" }
const _hoisted_4 = { class: "tw-flex tw-gap-[10px]" }
const _hoisted_5 = { class: "tw-bg-[#387DFF] tw-inline-flex tw-px-[5px] tw-py-[3px] tw-rounded" }
const _hoisted_6 = { class: "tw-text-white tw-text-[11px] tw-font-medium tw-leading-[130%]" }
const _hoisted_7 = { class: "tw-bg-[#F2F8FF] tw-inline-flex tw-px-[5px] tw-py-[3px] tw-rounded" }
const _hoisted_8 = { class: "tw-text-[#387DFF] tw-text-[11px] tw-font-medium tw-leading-[130%]" }
const _hoisted_9 = {
  key: 0,
  class: "prefilled"
}
const _hoisted_10 = { class: "tw-flex tw-gap-[15px]" }
const _hoisted_11 = { class: "tw-flex tw-items-center" }
const _hoisted_12 = { class: "tw-inline-block tw-pl-1" }
const _hoisted_13 = {
  key: 0,
  class: "info-icon tw-ml-[15px] md:tw-ml-[25px]"
}
const _hoisted_14 = { class: "tw-p-[15px] tw-w-[475px]" }
const _hoisted_15 = { class: "tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins" }
const _hoisted_20 = {
  key: 1,
  class: "tw-flex tw-items-center tw-gap-[10px]"
}
const _hoisted_21 = { class: "dropdown-container tw-flex-1 dropdown tw-max-w-[335px]" }
const _hoisted_22 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-gap-[20px] additionalInfo tw-flex-col tw-items-start`)
}
const _hoisted_23 = { class: "tw-flex tw-flex-col tw-gap-[20px] tw-justify-center tw-items-end" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M11.8741 6.38894L6.38429 0.165448C6.33485 0.113191 6.27527 0.0715663 6.2092 0.0431191C6.14312 0.0146718 6.07194 -2.59124e-07 6 -2.62268e-07C5.92806 -2.65413e-07 5.85688 0.0146718 5.7908 0.0431191C5.72473 0.0715663 5.66515 0.113191 5.61571 0.165448L0.125859 6.38894C0.081969 6.43838 0.0483386 6.49604 0.02692 6.55858C0.00550146 6.62113 -0.00327902 6.6873 0.00108975 6.75327C0.0065009 6.81976 0.0251891 6.8845 0.056049 6.94364C0.086909 7.00279 0.129313 7.05515 0.180757 7.09763L1.10405 7.8712C1.15449 7.91483 1.21315 7.9479 1.27658 7.96848C1.34002 7.98905 1.40693 7.9967 1.47337 7.99098C1.53949 7.9862 1.604 7.96828 1.66313 7.93829C1.72225 7.9083 1.77481 7.86683 1.81773 7.8163L5.91516 3.10002C5.94039 3.07503 5.97447 3.06101 6.00998 3.06101C6.04549 3.06101 6.07957 3.07503 6.10481 3.10002L10.1823 7.8163C10.2629 7.91267 10.377 7.97505 10.5017 7.99098C10.5678 7.99738 10.6345 7.99052 10.6979 7.97081C10.7613 7.9511 10.8202 7.91893 10.871 7.87619L11.8192 7.09763C11.8707 7.05515 11.9131 7.00279 11.9439 6.94364C11.9748 6.8845 11.9935 6.81976 11.9989 6.75327C12.0033 6.6873 11.9945 6.62113 11.9731 6.55859C11.9517 6.49604 11.918 6.43838 11.8741 6.38894Z",
  fill: "#DBDBDB"
}, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-items-center tw-gap-[20px]`)
}
const _hoisted_27 = {
  key: 0,
  class: "tw-flex tw-gap-[20px] tw-items-center others"
}
const _hoisted_28 = {
  key: 0,
  class: "tw-h-[35px] tw-w-[35px]"
}
const _hoisted_29 = { class: "tw-relative tw-border-[1.5px] tw-border-solid tw-border-[#EFF0F1] tw-flex tw-items-center tw-justify-center tw-h-[37px] tw-px-[20px] tw-rounded-[100px] tw-text-center tw-text-[#387DFF] tw-text-[13px] tw-font-[500] tw-font-[Poppins] tw-whitespace-nowrap add-item-button`" }
const _hoisted_30 = {
  key: 0,
  class: "tw-h-[35px] tw-w-[35px] tw-absolute"
}
const _hoisted_31 = {
  key: 2,
  class: "tw-flex tw-gap-[20px]"
}

import {
  Ref,
  ref,
  watch,
  computed,
  onMounted,
  PropType,
  ComputedRef,
} from "vue";
import ToggleIcon from "../svgs/toggleIcon.vue";
import AssessmentAnswerType1 from "./assessmentAnswerType1.vue";
import {
  MODAL_NAME,
  RIGHT_SLIDE_MODAL_NAME,
  TYPE_MODAL_SECURING_EVIDENCE,
  assessmentAdditionalInfoType,
  assessmentQuestionAnswerType,
  assessmentQuestionVisibleState,
  checklistStatusId,
  successStatusCodes,
} from "@/utils/constants";
import PinIcon from "../svgs/pinIcon.vue";
import PenIcon from "../svgs/penIcon.vue";
import CircularProgressPercent from "../common/circularProgressPercent.vue";
import AssessmentQuestionPrefilledTag from "../assessment/assessmentQuestionPrefilledTag.vue";
import ExpandingButton from "../common/expandingButton.vue";
import { getComponentUiText } from "@/utils/utilities";
import { IModalMessage } from "@/interfaces/common/common";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import ButtonShowMore from "../common/setting/buttonShowMore.vue";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import Button4 from "../common/button4.vue";
import store from "@/store";
import CustomBDropDown from "../common/customBDropDown.vue";
import CustomBDropDownItem from "../common/customBDropDownItem.vue";
import {
  IAssessmentChecklistItem,
  IAssessmentQuestionType,
} from "@/interfaces/assessments/IAssessmentDetails";
import AssessmentAdditionalInfo from "./assessmentAdditionalInfo.vue";
import SuggestionButton from "../common/suggestionButton.vue";
import { useRoute } from "vue-router";
import { addItemFromMaster, postAnswerQuestion } from "@/services/assessment";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";
import { onUnmounted } from "vue";
import { Handler } from "mitt";
import ProgressAnimation from "@/assets/animation/progress_light.json";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Assessment, Checklist } from "@/services/apiRoutes/routes";
import { LottieAnimation } from "lottie-web-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentQuestion',
  props: {
  checklistId: { type: Number, default: 0 },
  checklistItemId: { type: Number, default: 0 },
  isSelected: { type: Boolean, default: false, required: true },
  prefilledSource: { type: String, default: "" },
  level: { type: Number, default: 0 },
  suggestion: { type: Number, default: null },
  isAssessmentInput: { type: Boolean, default: false, required: false },
  isShowModalSearch: { type: Boolean, default: false, required: false },
  isSearchAll: { type: Boolean, default: true, required: false },
  selectedQuestions: {
    type: Array as () => any[],
    default: () => [],
  },
  checklistItemIsExcluded: { type: Boolean, default: false },
  isExclude: { type: Boolean, default: false },
  isInOtherCategory: { type: Boolean, default: false },
  checklistItem: {
    type: Object as PropType<IAssessmentChecklistItem>,
    default: () => ({}),
  },
  index: { type: Number, default: 0 },
},
  emits: [
  "select",
  "unselect",
  "update:answer",
  "onAnswer",
  "moreAction",
  "update:childAnswers",
  "openEvidenceModal",
  "exclude",
  "update:child-answer",
  "update:selectedQuestions",
],
  setup(__props, { emit: emits }) {

const props = __props;



let setTimeOutRef: any = null;
const route = useRoute();
const onHover: Ref<boolean> = ref(false);
const isCollapsed: Ref<boolean> = ref(true);
const selectedChild: Ref<any[]> = ref([]);
const answerOption: Ref<any> = ref([null]);
const answerOptionsDropDown: Ref<any[]> = ref([]);
const passkeyQuestion: Ref<string> = ref("");
const isLoadingAnimation: Ref<boolean> = ref(false);
const isCallReset: Ref<boolean> = ref(false);

const checklistItemDataRaw: Ref<IAssessmentChecklistItem> = computed(() => {
  // Page assessment input. Only get data show in UI form "arrayChecklistOrigin" store.
  if (props.isAssessmentInput) {
    const item = store.getters["Assessment/getCurrentChecklistItem"](
      props.checklistItemId,
    );
    const showQuestionItemIds =
      props.checklistItem.checklistChildren?.map((i) => i.checklistItemId) ||
      [];
    if (
      showQuestionItemIds?.length !== item.checklistChildren?.length &&
      item.checklistChildren
    ) {
      return {
        ...item,
        orderNumber: props.checklistItem.orderNumber,
        checklistChildren: props.checklistItem.checklistChildren,
      };
    } else {
      return {
        ...item,
        orderNumber: props.checklistItem.orderNumber,
        checklistChildren: props.checklistItem.checklistChildren,
      };
    }
  } else
    return props.isSearchAll
      ? store.getters["Assessment/getChecklistItemCurrentAll"](
          props.checklistItemId,
        )
      : store.getters["Assessment/getCurrentChecklistItem"](
          props.checklistItemId,
        );
});

const checklistInforDetail = computed(() => {
  return store.state.Assessment.checklistInforDetail;
});

const checklistItemHasChildren: Ref<boolean | undefined> = computed(
  () =>
    checklistItemDataRaw.value &&
    checklistItemDataRaw.value.checklistChildren &&
    checklistItemDataRaw.value.checklistChildren.length > 0,
);

const prospectQuestionTypes: Ref<IAssessmentQuestionType[]> = computed(
  () => store.state.Assessment.assessmentQuestionTypes,
);

const isChecklistCompleted: ComputedRef<boolean> = computed(() => {
  const statusId =
    store.getters["Assessment/getChecklistInforDetail"].checklistStatusId;

  return (
    statusId === checklistStatusId.completed ||
    statusId === checklistStatusId.paused ||
    statusId === checklistStatusId.defunct
  );
});


const openEvidenceModal = () => {
  if (
    !passkeyQuestion.value &&
    checklistItemDataRaw.value.checklistItemAttachments?.length
  ) {
    openSecuringModal();
  } else {
    openEvidence();
  }
};

const openSecuringModal = () => {
  const emitData = {
    component: MODAL_NAME.MODAL_SECURING_EVIDENCE,
    properties: {
      type: TYPE_MODAL_SECURING_EVIDENCE.DECRYPT,
      checklistItemId: checklistItemDataRaw.value.checklistItemId,
      attachmentId: checklistItemDataRaw?.value.checklistItemAttachments[0]?.id,
    },
    events: {
      "update:data": (passkey, file) => {
        passkeyQuestion.value = passkey;
        openEvidence();
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const openEvidence = () => {
  if (
    isChecklistCompleted.value &&
    checklistItemDataRaw.value.checklistItemAttachments.length === 0
  )
    return;
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_EVIDENCE,
    properties: {
      value: {
        questionNumber: checklistItemDataRaw.value.orderNumber,
        questionTitle: `${checklistItemDataRaw.value.checklistItemName}${
          checklistItemDataRaw.value.subName
            ? ` | ${checklistItemDataRaw.value.subName}`
            : ""
        }`,
        category: checklistItemDataRaw.value.checklistItemComplianceTypeLabel,
        subCategory:
          checklistItemDataRaw.value.checklistItemHeadingLabel ||
          checklistItemDataRaw.value.checklistItemName ||
          "",
        checklistId: props.checklistId,
        checklistItemId: props.checklistItemId,
      },
      dataTableFile:
        checklistItemDataRaw.value.checklistItemAttachments?.filter(
          (i: any) => i.type === assessmentAdditionalInfoType.attachment,
        ),
      passkey: passkeyQuestion.value,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const onHoverIn = () => {
  if (setTimeOutRef) clearTimeout(setTimeOutRef);
  onHover.value = true;
};

const onHoverOut = () => {
  setTimeOutRef = setTimeout(() => {
    onHover.value = false;
  }, 10);
};

const handleAnswer = (answer: any) => {
  const filters = store.getters["Assessment/getFilters"];
  if (
    filters &&
    filters.length > 0 &&
    filters.some((o) => o.targetId === "itemCompleteValue" && o.value.id === 0)
  ) {
    isAnimate.value = true;
  }
  findAnswer(answer);
  emits("update:answer", answer);
};

const handleChildAnswer = (answer: any) => {
  findAnswer(answer);
  emits("update:child-answer", answer);
};

const handleSelect = (orderNumber: string) => {
  if (props.isSelected) emits("unselect", orderNumber);
  else emits("select", orderNumber);
};

const handleChildUnselect = (orderNumber: number) => {
  selectedChild.value = selectedChild.value.filter(
    (item) => item !== orderNumber,
  );
  emits("unselect", orderNumber);
};
const isAnimate = ref(false);

const handleUpdateChildAnswer = (
  answer: any,
  questionFormat: any,
  item: any,
  index: any,
) => {
  findAnswer(answer);
  emits("update:child-answer", { answer, questionFormat, item, index });
};

const showAdvancedRightModal = () => {
  let obj: any = {};
  const idParentGrouping1 =
    checklistItemDataRaw.value.checklistItemIdParentGrouping1;
  const idParentGrouping2 =
    checklistItemDataRaw.value.checklistItemIdParentGrouping2;
  const idParentGrouping3 =
    checklistItemDataRaw.value.checklistItemIdParentGrouping3;
  const lb1 =
    store.getters["Assessment/getCurrentChecklistItem"](idParentGrouping1)
      .checklistItemHeadingLabel ||
    store.getters["Assessment/getCurrentChecklistItem"](idParentGrouping1)
      .checklistItemName;
  const lb2 =
    store.getters["Assessment/getCurrentChecklistItem"](idParentGrouping2)
      .checklistItemHeadingLabel ||
    store.getters["Assessment/getCurrentChecklistItem"](idParentGrouping2)
      .checklistItemName;
  const lb3 =
    store.getters["Assessment/getCurrentChecklistItem"](idParentGrouping3)
      .checklistItemHeadingLabel ||
    store.getters["Assessment/getCurrentChecklistItem"](idParentGrouping3)
      .checklistItemName;
  if (
    checklistItemDataRaw.value.checklistItemIdParentGrouping1 &&
    checklistItemDataRaw.value.checklistItemIdParentGrouping2 &&
    checklistItemDataRaw.value.checklistItemIdParentGrouping3
  ) {
    obj.checklistItem2ndSubCategoryLabel = [lb1, lb2];
    obj.checklistItem3ndSubCategoryLabel = [lb3];
  } else if (
    checklistItemDataRaw.value.checklistItemIdParentGrouping1 &&
    checklistItemDataRaw.value.checklistItemIdParentGrouping2
  ) {
    obj.checklistItem2ndSubCategoryLabel = [lb1];
    obj.checklistItem3ndSubCategoryLabel = [lb2];
  } else if (checklistItemDataRaw.value.checklistItemIdParentGrouping1) {
    obj.checklistItem2ndSubCategoryLabel = [lb1];
  } else if (
    !checklistItemDataRaw.value.checklistItemIdParentGrouping1 &&
    !checklistItemDataRaw.value.checklistItemIdParentGrouping2 &&
    !checklistItemDataRaw.value.checklistItemIdParentGrouping3
  ) {
    obj.checklistItem2ndSubCategoryLabel = [
      getComponentUiText("app-component-assessments-input-question-other-1"),
    ];
  }
  const emitData: IModalMessage = {
    component: RIGHT_SLIDE_MODAL_NAME.ASSESSMENT_ADVANCED,
    properties: {
      checklistId: props.checklistId,
      checklistItemId: checklistItemDataRaw.value.checklistItemId,
      answerOptionsDropDown: answerOptionsDropDown.value,
      questionData: {
        ...checklistItemDataRaw.value,
        ...obj,
      },
      answerOption: answerOption.value,
      passkey: passkeyQuestion.value,
      // isRecommend: true,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_RIGHT_SLIDE_MODAL, emitData);
};

const showModalAddNoteAssessment = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_ADD_NOTE_ASSESSMENT,
    properties: {
      value: {
        questionNumber: checklistItemDataRaw.value.orderNumber,
        questionTitle: `${checklistItemDataRaw.value.checklistItemName}${
          checklistItemDataRaw.value.subName
            ? ` | ${checklistItemDataRaw.value.subName}`
            : ""
        }`,
        category: getComponentUiText(
          "app-component-assessments-checklists-assesssment-category-1",
        ),
        subCategory:
          checklistItemDataRaw.value.checklistItemHeadingLabel ||
          checklistItemDataRaw.value.checklistItemName ||
          "",
        note: checklistItemDataRaw.value.checklistItemNotes,
        checklistId: props.checklistId,
        checklistItemId: props.checklistItemId,
      },
      title: getComponentUiText(
        "app-component-assessment-add-note-modal-title-1",
      ),
      titleInut: getComponentUiText(
        "app-component-assessments-override-question-note-title-1",
      ),
      inutPlaceholder: getComponentUiText(
        "app-component-assessments-override-question-note-prompt-1",
      ),
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const findAnswer = (answer: any) => {
  answerOption.value = [
    answerOptionsDropDown.value.find((item) => item.value == answer),
  ];
};

const handleExclude = () => {
  if (isChecklistCompleted.value) return;
  emits("exclude", checklistItemDataRaw.value.checklistItemId);
  if (props.isSelected)
    handleChildUnselect(checklistItemDataRaw.value.checklistItemId);
};

const processData = () => {
  if (!checklistItemDataRaw.value) return;

  // Get Dropdown data when don't have value.
  if (answerOptionsDropDown.value.length === 0) {
    if (
      !checklistItemDataRaw.value.checklistItemComplianceTypeId ||
      typeof checklistItemDataRaw.value.checklistItemComplianceTypeId !==
        "string" ||
      checklistItemDataRaw.value.checklistItemComplianceTypeId.length === 0
    )
      return;

    const questionType =
      checklistItemDataRaw.value.checklistItemComplianceTypeId;
    const data = prospectQuestionTypes.value.find(
      (item) => item.id === questionType,
    );
    if (data) answerOptionsDropDown.value = data.complianceTypeValues;
    else answerOptionsDropDown.value = [];

    answerOptionsDropDown.value = answerOptionsDropDown.value.map(
      (option: any) => {
        const item = {
          ...option,
          name: option.label,
        };
        return item;
      },
    );
    findAnswer(checklistItemDataRaw.value.checklistItemComplianceTypeValue);
  }

  // Update answer when checklist data updated.
  findAnswer(checklistItemDataRaw.value.checklistItemComplianceTypeValue);
};

const initial = () => {
  EventEmitter.on(EmitterEvents.UPDATE_PASSWORD_ASSESSMENT_QUESTION, ((data: {
    password: string;
    checklistItemId: number;
  }) => {
    if (data.password && data.checklistItemId === props.checklistItemId) {
      passkeyQuestion.value = data.password;
    }
  }) as Handler<unknown>);

  processData();
};

onUnmounted(() => {
  EventEmitter.off(EmitterEvents.UPDATE_PASSWORD_ASSESSMENT_QUESTION);
});

const addItemAction = async () => {
  isLoadingAnimation.value = true;
  try {
    const activeCategoryId = store.getters["Assessment/getActiveCategory"];

    const res = await addItemFromMaster(
      Number(route.query.checklistId),
      [props.checklistItemId],
      activeCategoryId,
    );

    if (res) {
      const params = {
        checklistIdParam: Number(route.query.checklistId),
        showMasterItem: true,
        itemRemoved: props.checklistItemId,
      };

      await store.dispatch("Assessment/fetchChecklistByCategory", params);

      store.dispatch(
        "Assessment/fetchCheckListIdMetricsCompletion",
        route.query.checklistId,
      );

      store.dispatch(
        "Assessment/getChecklistMetricScoreCompletion",
        route.query.checklistId,
      );

      store.dispatch("Assessment/fetchCategories", {
        checklistId: route.query.checklistId,
        reload: false,
      });

      showSuccessToast(getComponentUiText("app-toast-add-success-1"));
    }
  } catch (error) {
    showErrorAPI(error, Checklist.addItemFromMaster);
  } finally {
    isLoadingAnimation.value = false;
  }
};

const isShowAdditionInfo = () => {
  return (
    checklistItemDataRaw.value?.visibleState !==
      assessmentQuestionVisibleState.no &&
    (!(
      checklistItemDataRaw.value?.visibleState ===
      assessmentQuestionVisibleState.prefilled
    ) ||
      !isCollapsed.value) &&
    ((checklistItemDataRaw.value.additionalData &&
      checklistItemDataRaw.value.additionalData.length > 0) ||
      (checklistItemDataRaw.value.checklistItemNotes &&
        checklistItemDataRaw.value.checklistItemNotes !== "null"))
  );
};

onMounted(() => initial());
watch(() => checklistItemDataRaw, processData, { deep: true });
watch(
  () => prospectQuestionTypes,
  () => {
    if (
      !checklistItemDataRaw.value.checklistItemComplianceTypeId ||
      typeof checklistItemDataRaw.value.checklistItemComplianceTypeId !==
        "string" ||
      checklistItemDataRaw.value.checklistItemComplianceTypeId.length === 0
    )
      return;

    const questionType =
      checklistItemDataRaw.value.checklistItemComplianceTypeId;
    const data = prospectQuestionTypes.value.find(
      (item) => item.id === questionType,
    );
    if (data) answerOptionsDropDown.value = data.complianceTypeValues;
    else answerOptionsDropDown.value = [];

    answerOptionsDropDown.value = answerOptionsDropDown.value.map(
      (option: any) => {
        const item = {
          ...option,
          name: option.label,
        };
        return item;
      },
    );

    findAnswer(checklistItemDataRaw.value.checklistItemComplianceTypeValue);
  },
);

const handleSelectedQuestions = (item: any) => {
  emits("update:selectedQuestions", {
    item,
    selected: !props.isSelected,
    level: props.level,
  });
};

const showModalDuplicateQuestion = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_DUPLICATE_QUESTION,
    properties: {
      data: [checklistItemDataRaw.value],
      checklistId: Number(route.query.checklistId),
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const resetAnswer = async () => {
  isCallReset.value = true;
  if (
    checklistItemDataRaw.value.checklistItemIsExcluded ||
    checklistItemDataRaw.value.isMaster
  ) {
    return;
  }
  const checklistItemId = checklistItemDataRaw.value.checklistItemId;
  const checklistItems = [
    {
      checklistItemId,
      checklistItemComplianceTypeValueId: null,
      checklistItemComplianceOverride: null,
      checklistItemCompensatingControlValue: null,
      checklistItemCompensatingControlDescription: null,
    },
  ];
  const checklistItemsForDispatch = [
    {
      checklistItemId,
      checklistItemComplianceTypeValueId: null,
      checklistItemComplianceTypeValue: null,
      checklistItemComplianceOverride: null,
      checklistItemCompensatingControlValue: null,
      checklistItemCompensatingControlDescription: null,
    },
  ];

  try {
    const params = {
      checklistId: route.query.checklistId,
      checklistItems,
    };
    const paramsForDispatch = {
      checklistId: route.query.checklistId,
      checklistItems: checklistItemsForDispatch,
    };
    const result = await postAnswerQuestion(params);
    if (result.status === successStatusCodes.OK) {
      await store.dispatch(
        "Assessment/updateListCheckListItems",
        paramsForDispatch,
      );
      answerOption.value = [null];
      checklistItemDataRaw.value.checklistItemComplianceTypeValue = null;
      showSuccessToast(
        getComponentUiText("app-component-assessment-reset-answer-success-1"),
      );
    }
  } catch (error) {
    showErrorAPI(error, Assessment.postAnswerQuestion);
  } finally {
    isCallReset.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_AssessmentQuestion = _resolveComponent("AssessmentQuestion", true)!

  return (
      (checklistItemDataRaw.value.checklistItemHasChildren &&
        checklistItemDataRaw.value.checklistChildren?.length) ||
      !checklistItemDataRaw.value.checklistItemHasChildren
    )
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "assessment-question",
        class: _normalizeClass(`${isAnimate.value ? 'animate-fade-in' : ''} tw-flex tw-flex-col ${
      __props.level !== 0 && !isCollapsed.value ? '!md:tw-p-[20px]' : ''
    } ${__props.level === 2 ? 'tw-mb-[25px]' : ''} ${
      checklistItemHasChildren.value && !isCollapsed.value ? 'tw-gap-[25px]' : ''
    } ${
      !(
        checklistItemDataRaw.value?.visibleState ===
        _unref(assessmentQuestionVisibleState).prefilled
      ) || !isCollapsed.value
        ? __props.level === 0
          ? 'md:tw-p-[25px] tw-p-[10px]'
          : 'md:tw-p-[20px] tw-p-[10px]'
        : 'tw-px-[10px] md:tw-px-[25px] tw-py-[10px]'
    } tw-relative ${
      __props.level % 2 === 1 ? 'bgGrey' : __props.level !== 0 ? 'level2Bg' : ''
    } assessmentQuestion`),
        onMouseover: onHoverIn,
        onMouseout: onHoverOut
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("div", _hoisted_3, [
              _createVNode(ToggleIcon, {
                class: _normalizeClass(`${
              checklistItemDataRaw.value?.visibleState ===
              _unref(assessmentQuestionVisibleState).no
                ? `greyed`
                : 'tw-cursor-pointer'
            }`),
                ticked: __props.isSelected,
                color: "#387DFF",
                onClick: _cache[0] || (_cache[0] = () => handleSelect(checklistItemDataRaw.value.orderNumber))
              }, null, 8, ["class", "ticked"]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(checklistItemDataRaw.value.checklistItemCategoryLabel), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(checklistItemDataRaw.value.checklistItemHeadingLabel ||
                  checklistItemDataRaw.value.checklistItemName ||
                  ""), 1)
                ])
              ])
            ], 512), [
              [_vShow, __props.isShowModalSearch]
            ]),
            _createElementVNode("div", {
              style: _normalizeStyle(`${__props.checklistItemIsExcluded ? 'pointer-events: none;' : ''} `),
              class: "tw-flex tw-gap-[15px] tw-w-full"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(`${
              checklistItemDataRaw.value?.visibleState ===
              _unref(assessmentQuestionVisibleState).no
                ? ``
                : ''
            } tw-flex tw-items-center tw-justify-start tw-gap-[15px] tw-h-[fit-content]`)
              }, [
                _withDirectives(_createVNode(ToggleIcon, {
                  class: "tw-cursor-pointer",
                  ticked: __props.isSelected,
                  color: "#387DFF",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSelectedQuestions(checklistItemDataRaw.value)))
                }, null, 8, ["ticked"]), [
                  [_vShow, !__props.isShowModalSearch]
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["tw-text-[#231F20] tw-text-center tw-text-base tw-not-italic tw-font-semibold tw-leading-[normal] serialNo", `${!__props.isShowModalSearch ? '' : 'tw-pl-[30px]'}`])
                }, _toDisplayString(checklistItemDataRaw.value.orderNumber), 3)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(`tw-flex tw-flex-col ${
              !(
                checklistItemDataRaw.value?.visibleState ===
                _unref(assessmentQuestionVisibleState).prefilled
              ) || !isCollapsed.value
                ? 'tw-gap-[20px]'
                : ''
            } tw-w-full questionWrapper`)
              }, [
                (
                checklistItemDataRaw.value?.visibleState ===
                _unref(assessmentQuestionVisibleState).prefilled
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(AssessmentQuestionPrefilledTag, {
                        "number-question": '',
                        text: __props.prefilledSource,
                        color: "green",
                        expand: !isCollapsed.value
                      }, null, 8, ["text", "expand"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`${
                  checklistItemDataRaw.value?.visibleState ===
                  _unref(assessmentQuestionVisibleState).no
                    ? `greyed`
                    : ''
                } tw-flex tw-items-center tw-text-[#231F20] tw-text-[16px] tw-not-italic tw-font-normal tw-leading-[normal] ${
                  checklistItemDataRaw.value?.visibleState ===
                    _unref(assessmentQuestionVisibleState).prefilled && isCollapsed.value
                    ? 'collapsed'
                    : 'open'
                } question`)
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                      __props.level === 0 ? 'tw-max-w-[565px]' : '',
                      __props.level === 1 ? 'tw-max-w-[465px]' : '',
                      __props.level === 2 ? 'tw-max-w-[365px]' : '',
                      __props.level === 3 ? 'tw-max-w-[265px]' : '',
                    ])
                      }, [
                        _renderSlot(_ctx.$slots, "default"),
                        _createElementVNode("div", _hoisted_12, [
                          (
                          checklistItemDataRaw.value?.visibleState ===
                            _unref(assessmentQuestionVisibleState).no &&
                          checklistItemDataRaw.value.isMaster
                        )
                            ? (_openBlock(), _createBlock(AssessmentQuestionPrefilledTag, {
                                key: 0,
                                "number-question": '',
                                text: 
                          _unref(getComponentUiText)(
                            'app-component-assessments-question-answer-type-no-action-1',
                          )
                        ,
                                color: `blue`,
                                expand: true,
                                prefilled: false
                              }, null, 8, ["text"]))
                            : _createCommentVNode("", true)
                        ])
                      ], 2),
                      (
                      (checklistItemDataRaw.value.checklistItemDescription ||
                        checklistItemDataRaw.value.checklistItemGuidance) &&
                      onHover.value
                    )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _createVNode(ButtonShowDuplicateAssessment, {
                              "id-popover": 
                        'popover-button-show-duplicate-assessment-question-' +
                        __props.checklistItemId +
                        __props.index
                      ,
                              "custom-class": 'tw-w-[max-content] tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]',
                              class: _normalizeClass(`!tw-p-0 tw-leading-[16px]`),
                              classes: `!tw-leading-none tw-flex tw-items-center tw-justify-center`
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("div", _hoisted_15, [
                                    (checklistItemDataRaw.value.checklistItemDescription)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                          _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(getComponentUiText)(
                                  "app-menu-submenu-assessments-further-information-1",
                                )), 1),
                                          _createVNode(CustomDescriptionContent, {
                                            description: 
                                checklistItemDataRaw.value.checklistItemDescription
                              ,
                                            class: _normalizeClass(`!tw-p-0 tw-text-[13px] tw-text-[#878787]`)
                                          }, null, 8, ["description"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (checklistItemDataRaw.value.checklistItemGuidance)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(getComponentUiText)(
                                  "app-menu-submenu-assessments-guidance-1",
                                )), 1),
                                          _createVNode(CustomDescriptionContent, {
                                            description: 
                                checklistItemDataRaw.value.checklistItemGuidance
                              ,
                                            class: _normalizeClass(`!tw-p-0 tw-text-[13px] tw-text-[#878787]`)
                                          }, null, 8, ["description"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["id-popover"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(`${
                checklistItemDataRaw.value?.visibleState ===
                  _unref(assessmentQuestionVisibleState).prefilled && isCollapsed.value
                  ? 'collapsed'
                  : 'open'
              } ${
                checklistItemDataRaw.value?.visibleState ===
                _unref(assessmentQuestionVisibleState).no
                  ? `greyed`
                  : ''
              } answer`)
                }, [
                  (
                  checklistItemDataRaw.value.answerType ===
                    _unref(assessmentQuestionAnswerType).radio &&
                  !checklistItemDataRaw.value.checklistChildren?.length
                )
                    ? (_openBlock(), _createBlock(AssessmentAnswerType1, {
                        key: 0,
                        value: checklistItemDataRaw.value.checklistItemComplianceTypeValue,
                        suggestion: __props.suggestion,
                        disabled: 
                  isChecklistCompleted.value ||
                  checklistItemDataRaw.value.checklistItemComplianceOverride !==
                    null ||
                  checklistItemDataRaw.value.checklistItemCompensatingControlValue !==
                    null
                ,
                        excluded: 
                  checklistItemDataRaw.value?.visibleState ===
                  _unref(assessmentQuestionVisibleState).no
                ,
                        "on-hover": onHover.value,
                        onOnUpdate: handleAnswer
                      }, null, 8, ["value", "suggestion", "disabled", "excluded", "on-hover"]))
                    : _createCommentVNode("", true),
                  (
                  checklistItemDataRaw.value.answerType ===
                    _unref(assessmentQuestionAnswerType).select &&
                  !checklistItemDataRaw.value.checklistChildren?.length
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          (
                      checklistItemDataRaw.value.answerType ===
                        _unref(assessmentQuestionAnswerType).select &&
                      answerOptionsDropDown.value.length
                    )
                            ? (_openBlock(), _createBlock(CustomBDropDown, {
                                key: 0,
                                id: 'answerOption',
                                disabled: 
                      isChecklistCompleted.value ||
                      checklistItemDataRaw.value.checklistItemComplianceOverride !==
                        null ||
                      checklistItemDataRaw.value.checklistItemCompensatingControlValue !==
                        null
                    ,
                                data: answerOption.value,
                                "class-name": 
                      'gray-dropdown-container tw-h-[58px] ' +
                      'white-background'
                    ,
                                placeholder: 
                      _unref(getComponentUiText)(
                        'app-component-assessments-assessment-question-chose-answer-prompt-1',
                      )
                    
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answerOptionsDropDown.value, (item) => {
                                    return (_openBlock(), _createBlock(CustomBDropDownItem, {
                                      key: item.id,
                                      data: item,
                                      "class-name": 'normal-dropdown-container',
                                      onClick: ($event: any) => (handleAnswer(item.value))
                                    }, null, 8, ["data", "onClick"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["disabled", "data", "placeholder"]))
                            : _createCommentVNode("", true)
                        ]),
                        (__props.suggestion || __props.suggestion === 0)
                          ? (_openBlock(), _createBlock(SuggestionButton, {
                              key: 0,
                              value: __props.suggestion.toString() as any,
                              label: 
                    answerOptionsDropDown.value.find(
                      (item) => item.value === __props.suggestion,
                    )?.label
                  ,
                              style: _normalizeStyle({
                    visibility: onHover.value ? 'visible' : 'hidden',
                  }),
                              onOnClicked: _cache[2] || (_cache[2] = (value) => handleAnswer(value))
                            }, null, 8, ["value", "label", "style"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                (isShowAdditionInfo())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checklistItemDataRaw.value.additionalData as any, ({ type, attachments, text, href }, idx) => {
                        return (_openBlock(), _createBlock(AssessmentAdditionalInfo, {
                          key: idx,
                          type: type,
                          attachments: attachments || [],
                          text: text ? text : '',
                          href: href ? href : '',
                          "checklist-item-id": checklistItemDataRaw.value.checklistItemId,
                          "is-hovered": onHover.value,
                          "passkey-question": passkeyQuestion.value,
                          onViewAttachments: openEvidenceModal,
                          onViewInfo: showModalAddNoteAssessment
                        }, null, 8, ["type", "attachments", "text", "href", "checklist-item-id", "is-hovered", "passkey-question"]))
                      }), 128)),
                      (
                  checklistItemDataRaw.value.checklistItemNotes &&
                  checklistItemDataRaw.value.checklistItemNotes !== 'null'
                )
                        ? (_openBlock(), _createBlock(AssessmentAdditionalInfo, {
                            key: 0,
                            type: _unref(assessmentAdditionalInfoType).notes,
                            "note-text": checklistItemDataRaw.value.checklistItemNotes,
                            onViewAttachments: openEvidenceModal,
                            onViewInfo: showModalAddNoteAssessment
                          }, null, 8, ["type", "note-text"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_23, [
            (
            checklistItemDataRaw.value?.visibleState ===
            _unref(assessmentQuestionVisibleState).prefilled
          )
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "tw-cursor-pointer tw-absolute md:tw-relative md:tw-top-[unset] tw-top-[22px] tw-right-[18px] arrow",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (isCollapsed.value = !isCollapsed.value))
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "12",
                    height: "8",
                    viewBox: "0 0 12 8",
                    fill: "none",
                    style: _normalizeStyle(isCollapsed.value ? 'transform: rotate(180deg)' : '')
                  }, _hoisted_25, 4))
                ]))
              : _createCommentVNode("", true),
            (
            !(
              checklistItemDataRaw.value?.visibleState ===
              _unref(assessmentQuestionVisibleState).prefilled
            ) || !isCollapsed.value
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  (
              !checklistItemHasChildren.value &&
              checklistItemDataRaw.value?.visibleState !==
                _unref(assessmentQuestionVisibleState).no &&
              onHover.value
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createVNode(ExpandingButton, {
                          color: "#387DFF",
                          icon: PenIcon,
                          text: 
                _unref(getComponentUiText)(
                  'app-component-assessments-override-question-note-title-1',
                )
              ,
                          onClick: showModalAddNoteAssessment
                        }, null, 8, ["text"]),
                        _createVNode(ExpandingButton, {
                          class: _normalizeClass(
                isChecklistCompleted.value &&
                checklistItemDataRaw.value.checklistItemAttachments?.length === 0
                  ? '!tw-transform-none'
                  : ''
              ),
                          color: 
                isChecklistCompleted.value &&
                checklistItemDataRaw.value.checklistItemAttachments?.length === 0
                  ? '#62a2f5'
                  : '#387DFF'
              ,
                          icon: PinIcon,
                          text: 
                _unref(getComponentUiText)(
                  'app-component-assessments-evidence-button-title-1',
                )
              ,
                          "max-width": "95px",
                          onClick: openEvidenceModal
                        }, null, 8, ["class", "color", "text"]),
                        _createElementVNode("div", null, [
                          (isCallReset.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createVNode(_unref(LottieAnimation), {
                                  ref: "anim",
                                  "animation-data": _unref(ProgressAnimation),
                                  "auto-play": true,
                                  loop: true
                                }, null, 8, ["animation-data"])
                              ]))
                            : (_openBlock(), _createBlock(ButtonShowMore, {
                                key: 1,
                                "id-popover": 
                  'popover-btn-show-more-assessment-question-' +
                  __props.index +
                  checklistItemDataRaw.value.checklistItemId
                
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(CustomDropDownItem, {
                                    style: 'normal',
                                    "id-text": 'app-component-assessments-advanced-title-1',
                                    "style-text": '!tw-self-auto',
                                    onClick: showAdvancedRightModal
                                  }),
                                  (
                    checklistInforDetail.value.checklistStatusId ===
                      _unref(checklistStatusId).inProgress ||
                    checklistInforDetail.value.checklistStatusId ===
                      _unref(checklistStatusId).created
                  )
                                    ? (_openBlock(), _createBlock(CustomDropDownItem, {
                                        key: 0,
                                        style: _normalizeStyle(`tw-self-center ${
                    isChecklistCompleted.value
                      ? '!tw-cursor-not-allowed normal'
                      : 'normal'
                  }`),
                                        "id-text": 'app-component-assessments-exclude-1',
                                        "style-text": '!tw-self-auto',
                                        onClick: handleExclude
                                      }, null, 8, ["style"]))
                                    : _createCommentVNode("", true),
                                  (
                    checklistInforDetail.value.checklistStatusId ===
                      _unref(checklistStatusId).inProgress ||
                    checklistInforDetail.value.checklistStatusId ===
                      _unref(checklistStatusId).created
                  )
                                    ? (_openBlock(), _createBlock(CustomDropDownItem, {
                                        key: 1,
                                        style: 'normal',
                                        "id-text": 'app-component-assess-input-popover-duplicate-question-1',
                                        "style-text": '!tw-self-auto',
                                        onClick: showModalDuplicateQuestion
                                      }))
                                    : _createCommentVNode("", true),
                                  (
                    checklistInforDetail.value.checklistStatusId ===
                      _unref(checklistStatusId).inProgress ||
                    checklistInforDetail.value.checklistStatusId ===
                      _unref(checklistStatusId).created
                  )
                                    ? (_openBlock(), _createBlock(CustomDropDownItem, {
                                        key: 2,
                                        style: 'normal',
                                        "id-text": 'app-component-assessments-question-individual-action-item-reset-answer-1',
                                        "style-text": '!tw-self-auto',
                                        onClick: resetAnswer
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["id-popover"]))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (checklistItemDataRaw.value.isMaster)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: addItemAction
                      }, [
                        _createElementVNode("button", _hoisted_29, [
                          (isLoadingAnimation.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createVNode(_unref(LottieAnimation), {
                                  ref: "anim",
                                  "animation-data": _unref(ProgressAnimation),
                                  "auto-play": true,
                                  loop: true
                                }, null, 8, ["animation-data"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", {
                            class: _normalizeClass(isLoadingAnimation.value ? `tw-invisible` : ``)
                          }, _toDisplayString(_unref(getComponentUiText)(
                    "app-component-assessments-assessment-button-add-item-1",
                  )), 3)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        (
                checklistItemDataRaw.value.itemCompleteValue !== undefined &&
                !checklistItemDataRaw.value.checklistItemHasChildren
              )
                          ? (_openBlock(), _createBlock(CircularProgressPercent, {
                              key: 0,
                              percent: checklistItemDataRaw.value.itemCompleteValue,
                              "compensating-override-score": 
                checklistItemDataRaw.value.checklistItemCompensatingControlValue
              ,
                              "compliance-override-score": 
                checklistItemDataRaw.value.checklistItemComplianceOverride
              ,
                              class: _normalizeClass('tw-cursor-pointer'),
                              excluded: 
                checklistItemDataRaw.value?.visibleState ===
                _unref(assessmentQuestionVisibleState).no
              ,
                              onClick: showAdvancedRightModal
                            }, null, 8, ["percent", "compensating-override-score", "compliance-override-score", "excluded"]))
                          : _createCommentVNode("", true),
                        (
                checklistItemDataRaw.value?.visibleState ===
                _unref(assessmentQuestionVisibleState).no
              )
                          ? (_openBlock(), _createBlock(Button4, {
                              key: 1,
                              class: _normalizeClass(`tw-self-center ${
                isChecklistCompleted.value ? '!tw-cursor-not-allowed' : ''
              }`),
                              onClick: handleExclude
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-component-assessments-include-1")), 1)
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true)
                      ]))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (checklistItemHasChildren.value && __props.isSearchAll)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`tw-rounded-[4px] tw-mt-[20px] ${
        __props.level % 2 === 0 ? 'md:tw-pl-[52px]' : 'md:tw-pl-[58px]'
      } tw-flex tw-flex-col ${
        checklistItemDataRaw.value?.visibleState ===
          _unref(assessmentQuestionVisibleState).prefilled && isCollapsed.value
          ? 'collapsed'
          : 'open'
      }`)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checklistItemDataRaw.value.checklistChildren, (data, idx, ___, _cached) => {
                const _memo = ([data, __props.selectedQuestions])
                if (_cached && _cached.key === data.checklistItemId && _isMemoSame(_cached, _memo)) return _cached
                const _item = (_openBlock(), _createBlock(_component_AssessmentQuestion, {
                  id: String(data.checklistItemId),
                  key: data.checklistItemId,
                  index: idx,
                  "checklist-item": data,
                  suggestion: data?.suggestion,
                  "checklist-id": __props.checklistId,
                  "is-in-other-category": __props.isInOtherCategory,
                  "selected-questions": __props.selectedQuestions,
                  class: "tw-rounded-[4px] tw-mb-[25px]",
                  "is-selected": __props.selectedQuestions.includes(data.checklistItemId),
                  "prefilled-source": data.prefilledSource,
                  level: __props.level + 1,
                  "checklist-item-id": __props.isAssessmentInput ? data.checklistItemId : null,
                  "is-assessment-input": __props.isAssessmentInput,
                  "checklist-item-is-excluded": data.checklistItemIsExcluded,
                  "is-exclude": __props.isExclude,
                  onExclude: _cache[4] || (_cache[4] = (id) => emits('exclude', id)),
                  "onUpdate:selectedQuestions": _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:selectedQuestions', $event))),
                  "onUpdate:childAnswer": _cache[6] || (_cache[6] = 
          (value) => {
            emits('update:child-answer', value);
          }
        ),
                  "onUpdate:answer": 
          (value) =>
            handleUpdateChildAnswer(value, data.checklistItemId, data, idx)
        
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.checklistChildren && data.checklistChildren.length
            ? data.checklistItemHeadingLabel
            : data.checklistItemName) + _toDisplayString(data.subName ? ` | ${data.subName}` : ""), 1)
                  ]),
                  _: 2
                }, 1032, ["id", "index", "checklist-item", "suggestion", "checklist-id", "is-in-other-category", "selected-questions", "is-selected", "prefilled-source", "level", "checklist-item-id", "is-assessment-input", "checklist-item-is-excluded", "is-exclude", "onUpdate:answer"]))
                _item.memo = _memo
                return _item
              }, _cache, 7), 128))
            ], 2))
          : _createCommentVNode("", true)
      ], 34))
    : _createCommentVNode("", true)
}
}

})